import React from 'react';
import ReactDOM from 'react-dom/client';
import "./App.css";
import 'bootstrap/dist/css/bootstrap.css';
// import './styles/custom-btsp.scss';
import Schedule from './Schedule';
// import AppAdmin from './AppAdmin';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Artists from './components/Artists/Artists';
import SoundCloudLogin from './components/SoundCloud/SoundCloudLogin';
import SoundCloudCallback from './components/SoundCloud/SoundCloudCallback';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { installDevErrorOverlayFilter } from './devErrorOverlay';

if (process.env.NODE_ENV === 'development') installDevErrorOverlayFilter();

const clientId = process.env.REACT_APP_GOOGLE_LOGIN_CLIENT_ID;

const waitForController = () =>
  new Promise((resolve) => {
    if (navigator.serviceWorker.controller) return resolve();
    const h = () => { navigator.serviceWorker.removeEventListener('controllerchange', h); resolve(); };
    navigator.serviceWorker.addEventListener('controllerchange', h);
  });

const start = async () => {
  if (!window.isSecureContext || !('serviceWorker' in navigator)) return;
  try {
    await navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
    await navigator.serviceWorker.ready;
    await waitForController();           // <-- make sure this tab is controlled
  } catch (e) {
    console.error('SW registration failed', e);
    return;
  }
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
};
start();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <GoogleOAuthProvider clientId={clientId}>
    <BrowserRouter>
      <Routes>
        <Route path="/soundcloud/login" element={<SoundCloudLogin />} />
        <Route path="/soundcloud/callback" element={<SoundCloudCallback />} />
        <Route path="/artists/*" element={<Artists />} />
        {/* <Route path="/admin/*" element={<AppAdmin />} /> */}
        <Route path="/" element={<Schedule />} />
      </Routes>
    </BrowserRouter>
  </GoogleOAuthProvider>
  // </React.StrictMode>
);
